import CheckboxContent from '@component/form/checkbox/content'
import useControl from '@component/mapbox/control/useControl'
import { SearchTypeMenuContent } from '@component/mapbox/searchType'
import { mapDataLayer } from '@plugin/google/gtm/modules/estimate'
import classNames from 'classnames'
import { isFunction, lowerCase } from 'lodash-es'
import { useCallback } from 'react'
import { useEstimateMapContext } from '../../context'


function TypeItem({
  visible,
  value,
  onChange,
  theme,
  text,
  children,
}) {
  const changeHandle = useCallback(val => {
    isFunction(onChange) && onChange(val)
    mapDataLayer.checkbox(lowerCase(text), val)
  }, [text, onChange])

  if (children) {
    return children
  }

  return (
    <CheckboxContent className='!flex' theme={theme} checked={value} onChange={changeHandle}>
      <div className={classNames('text-sm w-134', { 'xs-s:w-60': !visible })}>{text}</div>
    </CheckboxContent>
  )
}

export default function SearchTypeMenu({
  ...args
}) {

  const {
    showSale,
    showRent,
    showSold,
    showEstimate,
    toggleSale,
    toggleRent,
    toggleSold,
    toggleEstimate,
  } = useEstimateMapContext()

  return useControl(
    <SearchTypeMenuContent
      showSale={showSale}
      showRent={showRent}
      showSold={showSold}
      showEstimate={showEstimate}
      toggleSale={toggleSale}
      toggleRent={toggleRent}
      toggleSold={toggleSold}
      toggleEstimate={toggleEstimate}
      saleText='For Sale'
      rentText='For Rent'
      soldText='Recently sold'
      estimateText='Estimated values'
      TypeItem={TypeItem}
      {...args}
    />,
    { position: 'top-right', groupClass: false, className: '!transform-none' }
  )
}